import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuto:false
  },
  getters: {
  },
  mutations: {
    setAuto(state,data){
      state.isAuto = data
    }
  },
  actions: {
  },
  modules: {
  }
})
